import { render } from "./Giants.vue?vue&type=template&id=bf6d7baa&lang=pug"
import script from "./Giants.vue?vue&type=script&lang=ts"
export * from "./Giants.vue?vue&type=script&lang=ts"

import "./Giants.vue?vue&type=style&index=0&id=bf6d7baa&lang=scss"
script.render = render

export default script